import { useForm } from 'react-hook-form';

import { RespondentType } from '../generated/referral-request';
import { toFormValues } from '../referral-request-form-utils';
import { type FormValues } from '../respondent-fields';

const useReferralRequestForm = (initialValues: FormValues | undefined, respondentTypes: RespondentType[]) =>
  useForm<FormValues>({ defaultValues: initialValues ?? toFormValues({ respondents: [] }, respondentTypes) });

export { useReferralRequestForm };
